import { render, staticRenderFns } from "./releaseDialog.vue?vue&type=template&id=13d02dca&scoped=true"
import script from "./releaseDialog.vue?vue&type=script&lang=js"
export * from "./releaseDialog.vue?vue&type=script&lang=js"
import style0 from "./releaseDialog.vue?vue&type=style&index=0&id=13d02dca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d02dca",
  null
  
)

export default component.exports